import { Component } from "@angular/core";

@Component({
  selector: "app-icon-title-underline",
  standalone: true,
  imports: [],
  templateUrl: "./title-underline.component.html",
})
export class TitleUnderlineIconComponent {}
